import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/apps/restatic/frontend/src/components/entities/error/index.tsx");
